import { render, staticRenderFns } from "./DraftIndicator.vue?vue&type=template&id=bbbaab32&scoped=true"
import script from "./DraftIndicator.js?vue&type=script&lang=js&external"
export * from "./DraftIndicator.js?vue&type=script&lang=js&external"
import style0 from "./DraftIndicator.scss?vue&type=style&index=0&id=bbbaab32&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbaab32",
  null
  
)

export default component.exports